import React from 'react';
import classNames from 'classnames';
import PDFExportFormActions from 'flux/actions/cuesheet.printable/PDFExportFormActions';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import TooltipConstants from 'shared/constants/TooltipConstants.jsx';
import { Tooltip } from 'bootstrap';

/**
 * Page break insert component
 */
// eslint-disable-next-line react/prop-types, react/display-name
export default ({ numCells, rowIndex, selected, scale, tableWidth }) => {
  if (rowIndex === 0) return null;

  const scaleTable = window.location.href.indexOf('custom') === -1;

  let inverseScale = 1 / scale;

  if (inverseScale < 1) inverseScale = 1;

  const scaleStyle = scaleTable
    ? {
        zoom: inverseScale,
      }
    : {};

  const classes = classNames(
    {
      selected,
    },
    'printable-page-break-insert-wrapper',
  );

  const pageBreakTooltip = selected
    ? TooltipConstants.RemovePageBreak
    : TooltipConstants.AddPageBreak;
  const iconName = selected ? 'minus-circle' : 'plus-circle';

  return (
    <tr className="printable-page-break-row" style={{ width: tableWidth }}>
      <td
        className="printable-page-break-cell"
        colSpan={numCells}
        style={scaleStyle}
      >
        <div
          className={classes}
          onClick={() => PDFExportFormActions.togglePageBreak(rowIndex)}
        >
          <Tooltip placement="top">{pageBreakTooltip}</Tooltip>
          <Icon name={iconName} />
          <Icon name="circle" className="white-circle-background" />
          <Icon name="circle" className="black-circle-outline" />
          <div className="pagebreak-cap-left" />
          <div className="pagebreak-cap-middle" />
          <div className="pagebreak-cap-right" />
          <div className="increase-clickable-area" />
        </div>
      </td>
    </tr>
  );
};
